import {GRANITE_10} from '@gaia/colors';
import theme from '@gaia/theme';

export default function FloatingCard({children, style}: React.HTMLProps<HTMLDivElement>) {
    return (
        <div
            style={{
                ...style,
                padding: theme.spacing(1),
                backgroundColor: GRANITE_10,
                borderRadius: '8px',
                boxShadow: `0px 2px 6px rgba(0, 0, 0, 0.4)`,
                display: 'flex',
                flexFlow: 'column nowrap',
                alignItems: 'center',
            }}
        >
            {children}
        </div>
    );
}
